import { module } from 'modujs';
import { lerp } from '../utils/maths';
import { transform } from '../utils/transform';

export default class extends module {
    constructor(m) {
        super(m);

        this.settings = {
            deltaDivider: 200,
            incrementFactor: 1
        }

        // const mydat = new dat.GUI()
        // mydat.add(this.settings, 'deltaDivider')
        // mydat.add(this.settings, 'incrementFactor')
    }

    init() {
        this.wrapper = this.$('wrapper')[0]
        this.items = this.$('item')

        this.compute()
        this.initTl()

        this.isRunnable = false;

        this.speed = 0;
        this.lerpedSpeed = 0;

        this.checkResizeBind = () => {
            if (this.resizeTick) return;
            this.resizeTick = true

            requestAnimationFrame(() => {
                this.compute()
                this.initTl()
                this.resizeTick = false
            })
        }
        window.addEventListener('resize', this.checkResizeBind)

    }

    compute() {
        this.viewport = { width: window.innerWidth, height: window.innerHeight }
        this.wrapperBCR = this.wrapper.getBoundingClientRect();
    }

    initTl() {
        if (this.tl && this.tl.kill) {
            this.tl.kill()
        }

        this.tl = gsap.timeline({
            // onUpdate: () => {
            //     const progress = this.tl.progress()

            //     let i = 0
            //     for (let item of Array.from(this.items)) {
            //         let delta = (-this.wrapperBCR.width + this.viewport.width) * progress
            //         delta = delta * 1366 / this.viewport.width // Some ratio thing
            //         gsap.set(item, {
            //             y: 40 * Math.sin(delta / this.settings.deltaDivider + i * this.settings.incrementFactor),
            //             force3D: true
            //         })
            //         i++;
            //     }
            // }
        });
        this.tl.fromTo(this.wrapper, { x: 0 }, { x: -this.wrapperBCR.width + this.viewport.width, force3D: true, ease: 'none' })
        this.tl.progress(0.1)
        this.tl.progress(0)
        this.tl.pause()
    }

    reachBoundary(args) {

        if (args.way == 'enter') {
            cancelAnimationFrame(this.raf);

            if (this.resetSpeedGsap != undefined) this.resetSpeedGsap.kill();
            this.isRunnable = true;
            this.render();
        } else {
            this.isRunnable = false;

            if (this.resetSpeedGsap != undefined) this.resetSpeedGsap.kill();
            this.resetSpeedGsap = gsap.to(this, {
                duration: 0.6,
                speed: 0,
                lerpedSpeed: 0,
                onComplete: () => {
                    cancelAnimationFrame(this.raf);
                }
            })
        }
        this.setProgress({ progress: args.obj.progress, speed: 0 })
    }

    setProgress(value) {

        this.tl.progress(Math.max(0, Math.min(1, value.progress)))
    }

    render() {
        this.raf = requestAnimationFrame(() => this.render());

        if (this.isRunnable) {
            this.speed = window.scroll.scroll.instance.speed;
            this.lerpedSpeed = lerp(this.lerpedSpeed, this.speed, 0.1);
        }

        this.items.forEach(item => {
            transform(item, `skewX(${this.lerpedSpeed * 0.2}deg)`);
        });
    }

    destroy() {
        super.destroy()

        if (this.tl && this.tl.kill) {
            this.tl.kill()
        }
        cancelAnimationFrame(this.raf);
        window.removeEventListener('resize', this.checkResizeBind)
    }
}
